import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { IMultiSelectOption, IMultiSelectSettings, IMultiSelectTexts } from 'ngx-bootstrap-multiselect';
import { contatoSituacoes } from '../pessoa-contato-situacao';

@Component({
    selector: 'sgt-pessoa-contato-situacao-multiselect',
    templateUrl: './pessoa-contato-situacao-multiselect.component.html',
    styleUrls: ['./pessoa-contato-situacao-multiselect.component.less']
})
export class PessoaContatoSituacaoMultiselectComponent implements OnInit {
    /** Situações dos contatos selecionados */
    @Input() situacoes: number[];
    /** Ao alterar a seleção das situações dos contatos */
    @Output() situacoesChange = new EventEmitter<number[]>();

    // Settings
    settings: IMultiSelectSettings;
    @Input() pullRight = false;
    @Input() enableSearch = true;
    @Input() showCheckAll = true;
    @Input() showUncheckAll = true;
    @Input() dynamicTitleMaxItems = 0;
    @Input() fixedTitle = false;
    /** Se deve exibir o multiselect acima */
    @Input() dropup = false;
    /** Se deve desabilitar o multiselect */
    @Input() disabled = false;

    // Texts
    texts: IMultiSelectTexts;
    @Input() checkAll = 'Selecionar Todas';
    @Input() uncheckAll = 'Limpar';
    @Input() defaultTitle = 'Nenhuma Situação';
    @Input() checked = 'Situação';
    @Input() checkedPlural = 'Situações';
    @Input() searchPlaceholder = 'Pesquisar...';
    @Input() allSelected = 'Todas Selecionadas';
    @Input() searchEmptyResult = 'Nenhuma situação encontrada';
    @Input() searchNoRenderText = 'Digite para pesquisar';

    // Options
    options: IMultiSelectOption[];

    ngOnInit() {
        // Settings
        this.settings = {
            pullRight: this.pullRight,
            enableSearch: this.enableSearch,
            containerClasses: `container-multiselect container-multiselect-pessoa-contato-situacao ${this.dropup ? 'dropup' : 'dropdown'}`,
            showCheckAll: this.showCheckAll,
            showUncheckAll: this.showUncheckAll,
            dynamicTitleMaxItems: this.dynamicTitleMaxItems,
            fixedTitle: this.fixedTitle
        };
        // Texts
        this.texts = {
            checkAll: this.checkAll,
            uncheckAll: this.uncheckAll,
            defaultTitle: this.defaultTitle,
            checked: this.checked,
            checkedPlural: this.checkedPlural,
            searchPlaceholder: this.searchPlaceholder,
            allSelected: this.allSelected,
            searchEmptyResult: this.searchEmptyResult,
            searchNoRenderText: this.searchNoRenderText
        };

        this.create();
    }

    /** Cria as situações dos contatos para o multiselect */
    private create() {
        this.options = [];
        const selects: IMultiSelectOption[] = [];

        contatoSituacoes.forEach(situacao => {
            selects.push({
                id: situacao.id,
                name: situacao.nome,
            });
        });
        this.options = selects;
    }

    /** Ao alterar a seleção das situações dos contatos */
    onChange() {
        this.situacoesChange.emit(this.situacoes);
    }
}
